import { IMG } from "./site";

export const INFO_PAGES = [
    {
        slug: "/depannage-serrure-boite-aux-lettres",
        title: "Dépannage serrure boîte aux lettres",
        kicker: "Dépannage — Paris & Île-de-France",
        metaTitle: "Dépannage Serrure Boîte aux Lettres Paris | Réparation & Changement 7/7",
        metaDesc: "Serrure boîte aux lettres Paris : dépannage, réparation et changement en Île-de-France. Ouverture non destructive, tarifs pas chers, agréé assurance. ☎ 06 25 25 86 19",
        intro: "Perte de clés, clé cassée dans la serrure, serrure forcée ou boîte vandalisée : nous intervenons dans la journée pour rétablir l'accès à votre courrier, dépanner ou changer la serrure de votre boîte aux lettres — un travail sérieux, au meilleur prix.",
        sections: [
            {
                h: "Ouverture d'une serrure de boîte aux lettres non verrouillée",
                ps: [
                    "Clé perdue ou volée ? Si la serrure de votre boîte aux lettres n'est pas verrouillée, vous pouvez régler l'incident vous-même : démontez la serrure (la batteuse, en langage professionnel) en dévissant les 2 boulons de maintien à l'aide d'une clé à molette, en conservant la came qui assure la fermeture de la porte.",
                    "Rendez-vous ensuite, serrure en main, chez votre quincaillier ou dans une grande enseigne de bricolage pour obtenir le même modèle et son jeu de clés. La pose de la nouvelle serrure et de la came se fait tout aussi simplement.",
                ],
            },
            {
                h: "Vous ne bricolez pas, ou votre serrure est verrouillée ?",
                ps: [
                    "Demandez l'intervention d'un serrurier-expert. Nous intervenons en journée à Paris et dans toute l'Île-de-France pour un dépannage dans les règles de l'art : problème de clé, dysfonctionnement du barillet ou batteuse coincée, nous analysons la situation pour vous proposer la solution la plus efficace.",
                    "Formés et outillés, nous pouvons procéder à une ouverture non destructive par lubrification ou crochetage, à la destruction et au remplacement du cylindre, ou au simple remplacement de la batteuse.",
                ],
                img: IMG("depannage-boite-aux-lettres-paris.webp"),
            },
            {
                h: "Location : qui paie en cas de vandalisme ?",
                ps: [
                    "Dans le cadre d'un bail de location, la réparation de la boîte aux lettres incombe au locataire. Mais si la boîte a été vandalisée dans les parties communes d'une copropriété, celle-ci doit être avisée par lettre recommandée avec accusé de réception — joignez une photographie datée des dégâts.",
                    "Il appartient au syndic de déposer plainte et d'aviser l'assurance de l'immeuble, qui prendra normalement en charge les frais de dépannage. En habitation individuelle, votre assurance habitation couvre généralement le vandalisme : vérifiez vos garanties et votre franchise, portez plainte, puis demandez-nous un devis.",
                ],
            },
            {
                h: "Les avantages et inconvénients de la serrure PTT",
                ps: [
                    "Les boîtes aux lettres normalisées (NF D 27 404 / NF D 27 405) utilisent l'une des 21 clés universelles agréées par La Poste : le facteur peut ouvrir votre boîte pour y déposer un colis, et vous pouvez lui demander d'ouvrir votre boîte en cas de perte de clé, sur justificatif d'identité.",
                    "Attention : le pass-PTT est en vente libre sur Internet — la clé unique s'acquiert pour moins de 10€ et le jeu complet pour moins de 100€. Avec ce type de serrure, votre courrier et vos colis ne sont pas sécurisés. La solution : une serrure personnalisée haute sécurité et la livraison de vos colis au point relais le plus proche.",
                ],
            },
            {
                h: "Remplacement à l'identique ou serrure renforcée",
                ps: [
                    "Lorsque la serrure doit être changée, vous pouvez opter pour un remplacement à l'identique ou pour une serrure à protection renforcée : votre courrier peut contenir des éléments de valeur (chèques, cartes bancaires). Nous proposons des dispositifs adaptés — serrure de sûreté 3 gorges ou batteuse haute sécurité — avec un devis clair et définitif.",
                    "Nous privilégions des marques reconnues pour leur fiabilité : si votre boîte est installée en extérieur, nous vous proposerons systématiquement une serrure en acier inoxydable ou alliage de zinc, résistante aux intempéries. Après l'intervention, une facture en bonne et due forme vous permet de vous faire rembourser par votre assurance.",
                ],
                img: IMG("changement-serrure-boite-aux-lettres-paris.webp"),
            },
        ],
        checklist: [
            "Ouverture non destructive par lubrification ou crochetage",
            "Remplacement de batteuse et de cylindre",
            "Serrure haute sécurité 3 gorges sur demande",
            "Devis clair : déplacement, pièces et main d'œuvre",
            "Facture pour remboursement assurance ou syndic",
            "Intervention dans la journée, 7j/7",
        ],
    },
    {
        slug: "/serrurier-bricard",
        title: "Serrurier Bricard",
        kicker: "Marques — Expertise certifiée",
        metaTitle: "Serrurier Bricard Paris — Dépannage Rapide & Ouverture de Porte 24/7",
        metaDesc: "Serrurier Bricard à Paris : artisans formés aux normes Bricard, ouverture de porte, dépannage d'urgence 24/7, installation de serrures. Devis clair avant intervention. ☎ 06 25 25 86 19",
        intro: "Connue pour sa qualité et son savoir-faire, la marque Bricard est l'une des plus recherchées du marché. Nos artisans sont formés aux normes Bricard : une connaissance profonde des produits, au service de votre sécurité.",
        sections: [
            {
                h: "Une gamme complète de services Bricard",
                ps: [
                    "Du simple dépannage à l'installation complète de systèmes de sécurité, nous couvrons tous vos besoins : ouverture de porte rapide et efficace si vous êtes bloqué dehors, dépannage d'urgence 24/7 en cas de serrure cassée ou d'effraction, et installation de toute la variété des serrures Bricard selon vos besoins spécifiques.",
                    "En tant que serrurier Bricard, nous avons accès aux dernières technologies en matière de sécurité et vous proposons des solutions de verrouillage avancées, avec des conseils d'experts pour entretenir vos serrures et améliorer votre sécurité globale.",
                ],
                img: IMG("serrurier-fichet-Paris.webp"),
            },
            {
                h: "Notre processus en 3 étapes",
                ps: [
                    "Première étape : le devis. Tout commence par un devis détaillé — une fois vos besoins compris, nous vous fournissons un devis complet qui détaille tous les coûts impliqués.",
                    "Deuxième étape : l'intervention. Une fois le devis accepté, nos artisans arrivent toujours bien préparés, avec tous les outils et équipements nécessaires.",
                    "Troisième étape : la finalisation. Après l'installation ou le dépannage, nous faisons un dernier contrôle pour nous assurer que tout fonctionne parfaitement.",
                ],
            },
            {
                h: "Questions fréquentes",
                ps: [
                    "Quelle est la durée de la garantie ? Tous nos travaux sont garantis, la durée dépendant du type de service effectué.",
                    "Faites-vous des interventions la nuit ? Oui, notre service d'urgence est ouvert 24/7.",
                    "Puis-je obtenir un devis en ligne ? Oui, nous offrons un service de devis en ligne pour une estimation rapide.",
                ],
            },
        ],
        checklist: [
            "Artisans formés aux normes Bricard",
            "Ouverture de porte rapide et sans casse",
            "Urgence 24/7 — effraction, serrure cassée",
            "Installation de toutes les serrures Bricard",
            "Devis clair et précis avant intervention",
            "Conseils d'entretien et de sécurité offerts",
        ],
    },
    {
        slug: "/serrurier-keso-jpm",
        title: "Serrurier Keso JPM",
        kicker: "Marques — Expertise certifiée",
        metaTitle: "Serrurier Keso JPM Paris — Dépannage Rapide & Ouverture de Porte 24/7",
        metaDesc: "Serrurier Keso JPM à Paris : ouverture de porte 24/7, dépannage cylindre coincé, installation. Serruriers certifiés, tarifs transparents, intervention en 30 min. ☎ 06 25 25 86 19",
        intro: "Keso JPM est une marque reconnue pour la durabilité et la fiabilité de ses serrures, conçues pour résister à l'usure du temps et offrir une protection optimale contre les tentatives d'effraction. Notre équipe de serruriers qualifiés intervient sur tous les modèles.",
        sections: [
            {
                h: "Pourquoi choisir Keso JPM ?",
                ps: [
                    "Sécurité accrue : une serrure Keso JPM offre une sécurité inégalée et résiste aux tentatives d'effraction, pour une tranquillité d'esprit totale.",
                    "Qualité supérieure : des produits conçus pour durer, reconnus pour leur fiabilité sur le long terme.",
                ],
                img: IMG("serrure-depannage-paris.webp"),
            },
            {
                h: "Nos services Keso JPM",
                ps: [
                    "Ouverture de porte : un problème avec une serrure Keso JPM ? Notre service d'urgence est disponible 24/7.",
                    "Dépannage : cylindre coincé ou clé perdue, notre équipe résout votre problème rapidement.",
                    "Devis : obtenez un devis gratuit pour tous vos besoins en serrurerie Keso JPM — il suffit de nous contacter.",
                ],
            },
            {
                h: "Expertise, formation et transparence",
                ps: [
                    "Nos serruriers sont certifiés pour intervenir sur tous les modèles Keso JPM, et nous investissons dans la formation continue de notre équipe pour une prestation à la pointe de la technologie.",
                    "Nos tarifs sont transparents et sans surprise — vous savez exactement ce que vous payez. Nous acceptons diverses méthodes de paiement, de la carte bancaire au virement. Nos clients apprécient notre rapidité d'intervention (généralement sous 30 minutes) et nos travaux sont garantis.",
                ],
            },
        ],
        checklist: [
            "Serruriers certifiés Keso JPM",
            "Intervention en 30 minutes en urgence",
            "Travaux garantis",
            "Tarifs transparents, sans surprise",
            "Formation continue de l'équipe",
            "Devis gratuit en ligne ou par téléphone",
        ],
    },
    {
        slug: "/locksmith-paris",
        title: "Locksmith Paris — Available 24/7",
        kicker: "English — Greater Paris Area",
        metaTitle: "Locksmith Paris — 06 25 25 86 19, Available 24/7 | At Your Place in 25 min",
        metaDesc: "Locksmith Paris: need a locksmith in Paris or the Greater Paris Area? Our expert locksmiths are available 24/7 for any emergency: locked door, lock repair, security solutions. Free quote, insurance approved. ☎ +33 6 25 25 86 19",
        intro: "Locked out of your home or office in Paris? Don't worry — Locksmith Paris is here to help! Our team of professional locksmiths is available 24 hours a day, 7 days a week to assist you with any locksmith emergency.",
        sections: [
            {
                h: "Locksmith Paris — Available 24/7 for Emergency Situations",
                ps: [
                    "With our SOS Keys service, we are always ready to respond to your call and quickly resolve any locked door situation. Whether you're locked out of your house or your office, our locksmiths will arrive on the scene promptly to open your locked door.",
                    "We understand the importance of fast and reliable locksmith services, which is why we offer emergency locksmith services for all residents and businesses in Paris. We are fully equipped with the latest tools and techniques to handle any locksmith job, big or small — our experienced locksmiths are trained to work on all types of locks, including high-security locks and digital locks.",
                ],
                img: IMG("ouverture-porte.webp"),
            },
            {
                h: "Locksmith Services in Paris and the Greater Paris Area",
                ps: [
                    "Our team of expert locksmiths will arrive at your home in just 25 minutes. We offer emergency locksmith services for all types of lock and security issues, and our team is equipped to handle any situation, big or small.",
                    "Our services are fully approved by insurance companies, so you can rest assured that your locksmith needs are in good hands. Get a free quote today, and experience peace of mind knowing that our team is just a phone call away — whether you need a simple lock repair or a more complex security solution, we have you covered.",
                ],
            },
        ],
        checklist: [
            "Available 24 hours a day, 7 days a week",
            "At your place in 25 minutes",
            "Insurance approved services",
            "Free quote — no hidden fees",
            "High-security and digital locks",
            "Paris and the entire Île-de-France",
        ],
    },
    {
        slug: "/depannage-serrurier",
        title: "Dépannage serrurier express",
        kicker: "Dépannage — 24/7",
        metaTitle: "Dépannage Serrurier Paris — Express 24/7, chez vous en 25 min",
        metaDesc: "Dépannage serrurier express sur Paris et Île-de-France : ouverture de porte, changement de serrure, rideau métallique, coffre-fort. 24h/24, 7j/7, devis gratuit. ☎ 06 25 25 86 19",
        intro: "Notre service de dépannage est disponible à tout moment, sans interruption le week-end ni les jours fériés. On ne peut pas prévenir la perte de clés ou un cambriolage : nous sommes toujours présents pour nos clients.",
        sections: [
            {
                h: "Un dépannage complet, de jour comme de nuit",
                ps: [
                    "Changement, pose ou réparation de toutes marques de serrures, poignées, verrous, canons simples ou doubles, portes blindées, gâches électriques : nos artisans interviennent sur toute la serrurerie, avec le matériel adapté à chaque situation.",
                    "Nos serruriers de garde répondent à toutes vos sollicitations — perte de clés, porte claquée, effraction — dans les 20 à 25 minutes suivant votre appel, sur Paris et toute l'Île-de-France.",
                ],
                img: IMG("serrurier-ouverture-de-porte.webp"),
            },
            {
                h: "Des tarifs annoncés avant l'intervention",
                ps: [
                    "Chaque dépannage commence par un devis gratuit et sans engagement. En urgence, nous établissons un document devis/facture détaillant chaque dépense : main d'œuvre et pièces. Le prix annoncé est le prix payé.",
                ],
            },
        ],
        checklist: [
            "Ouverture de porte — 60€ TTC",
            "Changement de serrure toutes marques",
            "Dépannage rideau métallique et volet roulant",
            "Intervention après cambriolage",
            "Chez vous en 25 minutes, 24h/24",
            "Agréé assurance — facture détaillée",
        ],
    },
    {
        slug: "/serrurier-pas-cher-paris",
        title: "Serrurier pas cher à Paris",
        kicker: "Tarifs — Transparence",
        metaTitle: "Serrurier Pas Cher Paris — Ouverture de Porte 60€ TTC, Devis Gratuit",
        metaDesc: "Serrurier pas cher à Paris : ouverture de porte 60€ TTC, changement de serrure dès 85€, double de clé dès 5€. Prix compétitifs sans compromis sur la qualité, devis gratuit. ☎ 06 25 25 86 19",
        intro: "Des services de serrurerie à des prix très compétitifs, sans jamais compromettre la qualité du travail : c'est l'engagement de notre équipe d'artisans, sur Paris et toute l'Île-de-France.",
        sections: [
            {
                h: "Des prix compétitifs, une qualité d'artisan",
                ps: [
                    "Ouverture de porte simple claquée : 60€ TTC, intervention comprise. Changement de serrure : 85€ de main d'œuvre. Double de clé : dès 5€. Coffre-fort : dès 150€. Blindage et rideau métallique : sur devis gratuit.",
                    "Nos tarifs sont TTC, annoncés avant l'intervention et consignés sur un devis gratuit. Un devis écrit vous est remis avant toute intervention — c'est la règle, et notre pratique quotidienne.",
                ],
                img: IMG("tarif-serrurier.webp"),
            },
            {
                h: "Pas cher ne veut pas dire low-cost",
                ps: [
                    "Un serrurier honnête ne propose jamais de « tout changer » si votre serrure est réparable, et ne profite pas de votre détresse en urgence. Nos artisans prennent le temps d'analyser le problème et de vous expliquer la solution, au juste prix.",
                ],
            },
        ],
        checklist: [
            "Ouverture de porte : 60€ TTC",
            "Changement de serrure : dès 85€",
            "Double de clé : dès 5€",
            "Devis gratuit et sans engagement",
            "Aucune majoration cachée",
            "Agréé assurance, dans le métier depuis 1985",
        ],
    },
    {
        slug: "/serrurier-paris-nuit",
        title: "Serrurier de nuit à Paris",
        kicker: "Urgence nocturne — 24/7",
        metaTitle: "Serrurier de Nuit Paris — Urgence 24h/24, Intervention 25 min",
        metaDesc: "Serrurier de nuit à Paris : porte claquée, clé perdue ou oubliée en rentrant ? Nos serruriers de garde interviennent 24h/24, week-ends et jours fériés, en 25 min. ☎ 06 25 25 86 19",
        intro: "En rentrant la nuit, vous réalisez que vous avez oublié ou perdu votre clé. Les portes d'aujourd'hui sont de plus en plus fiables et difficiles à ouvrir sans clé : votre seul secours, une équipe spécialisée en dépannage de nuit.",
        sections: [
            {
                h: "Des serruriers de garde, toutes les nuits",
                ps: [
                    "Notre service de nuit travaille 24h/24 sur Paris et toute l'Île-de-France — y compris le samedi, le dimanche et les jours fériés. Artisans disponibles même tard la nuit et tôt le matin, pour vous garantir le meilleur service SOS Serrurier Paris.",
                    "Nous intervenons auprès de nos clients dans les 20 à 25 minutes suivant votre appel téléphonique, avec tout l'équipement nécessaire pour une ouverture sans casse dans la grande majorité des cas.",
                ],
                img: `${process.env.PUBLIC_URL}/serrurier-nuit.webp`,
            },
            {
                h: "Le même prix, de jour comme de nuit",
                ps: [
                    "Chez nous, pas de surprise nocturne : le tarif vous est annoncé au téléphone avant le déplacement, et un devis/facture détaillé vous est remis sur place. L'ouverture d'une porte claquée reste à 60€ TTC, même à 3h du matin.",
                ],
            },
        ],
        checklist: [
            "Disponible 24h/24 — 7j/7",
            "Intervention en 25 minutes la nuit",
            "Ouverture sans casse privilégiée",
            "Tarif annoncé avant déplacement",
            "Week-ends et jours fériés inclus",
            "Paris et toute l'Île-de-France",
        ],
    },
    {
        slug: "/devis-porte-blindee",
        title: "Devis porte blindée",
        kicker: "Devis gratuit — Sécurisation",
        metaTitle: "Devis Porte Blindée Paris — Gratuit & Sans Engagement | Blindage A2P",
        metaDesc: "Devis porte blindée et blindage de porte à Paris : étude gratuite à domicile, serrures 3 à 7 points certifiées A2P, conforme aux exigences des assurances. ☎ 06 25 25 86 19",
        intro: "Le blindage de votre porte est la protection la plus efficace contre le cambriolage. Obtenez un devis gratuit et détaillé : nos experts étudient votre porte, votre niveau de sécurité souhaité et votre budget.",
        sections: [
            {
                h: "Blindage de votre porte existante ou porte blindée complète",
                ps: [
                    "Le blindage renforce votre porte actuelle avec une tôle d'acier, des corniches anti-pince et une serrure multipoints : efficace et plus économique, il préserve l'esthétique de votre porte.",
                    "La porte blindée complète offre le niveau de protection maximal : bloc-porte certifié, serrure haute sécurité intégrée, isolation renforcée. Idéale après un cambriolage ou pour un bien de valeur.",
                ],
                img: IMG("serrurier-paris.paris.webp"),
            },
            {
                h: "Un devis clair, conforme aux assurances",
                ps: [
                    "Chaque devis détaille la main d'œuvre, les pièces et le niveau de certification (A2P). Nos installations respectent les exigences des compagnies d'assurance : en cas de sinistre, votre conformité facilite l'indemnisation.",
                ],
            },
        ],
        checklist: [
            "Étude de sécurité gratuite à domicile",
            "Serrures 3 à 7 points certifiées A2P",
            "Corniches anti-pince et protège-gonds",
            "Devis détaillé : main d'œuvre et pièces",
            "Conforme aux exigences des assurances",
            "Garantie décennale sur la pose",
        ],
    },
    {
        slug: "/devis-serrurier-agree-assurance",
        title: "Devis serrurier agréé assurance",
        kicker: "Agréé assurance — Remboursement",
        metaTitle: "Devis Serrurier Agréé Assurance Paris — Gratuit, Remboursement Facilité",
        metaDesc: "Serrurier agréé assurance à Paris : devis gratuit et facture conforme pour votre remboursement après ouverture de porte ou cambriolage. Intervention 30 min, 24/7. ☎ 06 25 25 86 19",
        intro: "Notre entreprise de serrurerie est agréée par la majorité des compagnies d'assurance. Nos prestations sont conformes à leurs exigences, ce qui facilite votre remboursement après une ouverture de porte ou un cambriolage.",
        sections: [
            {
                h: "Des documents conformes pour votre assureur",
                ps: [
                    "Devis gratuit avant chaque intervention, facture détaillée après : chaque document distingue clairement la main d'œuvre et les pièces, avec nos coordonnées complètes — exactement ce que votre assurance réclame.",
                    "Après un cambriolage, nous intervenons en urgence pour sécuriser votre logement, et vous pouvez déposer une pré-plainte en ligne auprès de la police nationale pour accélérer votre dossier de remboursement.",
                ],
                img: IMG("serrurier-paris-agree-assurances.webp"),
            },
            {
                h: "Les marques reconnues par les assureurs",
                ps: [
                    "Nous installons des serrures certifiées A2P et des marques reconnues — Fichet, Bricard, JPM, Vachette, DOM — conformes aux exigences des contrats d'assurance habitation.",
                ],
            },
        ],
        checklist: [
            "Agréé par la majorité des compagnies d'assurance",
            "Devis gratuit et facture détaillée conforme",
            "Serrures certifiées A2P",
            "Intervention après cambriolage en urgence",
            "Conseils pour votre dossier de remboursement",
            "Marques Fichet, Bricard, JPM, Vachette, DOM",
        ],
    },
];
